import { render, staticRenderFns } from "./PageSet.vue?vue&type=template&id=d51db86c&scoped=true&"
import script from "./PageSet.vue?vue&type=script&lang=js&"
export * from "./PageSet.vue?vue&type=script&lang=js&"
import style0 from "./PageSet.vue?vue&type=style&index=0&id=d51db86c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51db86c",
  null
  
)

export default component.exports